var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_c('input',{attrs:{"type":"radio","name":_vm.name,"group":_vm.group},domProps:{"value":_vm.value,"checked":_vm.checked},on:{"change":_vm.change}}),_c('div',{staticClass:"radio"},[_vm._t("template")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }